module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-header', {
    staticClass: "topTitle",
    attrs: {
      "title": _vm.title
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/index"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "slot": "right",
      "icon": "more"
    },
    slot: "right"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9b3747e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topTitle.vue
// module id = 200
// module chunks = 17